import React from 'react';


const Indicators = props => {
    return (
        <React.Fragment>
            <hr className="summary-table-hr" />
            <h2>{ props.indicatorsTitle }</h2>
            <div className="indicators-container">
                {props.indicators.map(indicator => <button onClick={onClickButton} type="button" className="btn btn-dark" id={`in${indicator}`} key={indicator}>{indicator}</button>)}
                {
                    props.indicatorExtra ?
                         props.indicatorExtra.map(indicatorExtra => <a href={indicatorExtra.link} title={indicatorExtra.value} className="btn btn-dark extra" id={`in${indicatorExtra}`} key={indicatorExtra.value}>{indicatorExtra.value}</a>)
                    :
                    null
                }
            </div>
        </React.Fragment>
        
    ) 
}

const onClickButton = (e) => {
    let jumpOn = e.target.getAttribute('id').replace('in', 'section');
    document.getElementById(jumpOn).scrollIntoView();
}

export default Indicators;
